<script>import ButtonCarouselNext from "../../elements/buttons/variants/ButtonCarouselNext.svelte";
import ButtonCarouselPrev from "../../elements/buttons/variants/ButtonCarouselPrev.svelte";
import { attrValue } from "../../../utils/html";
export let next;
export let prev;
export let rounded;
export let classNames;
export let white;
</script>

<div data-glide-el="controls" class="{attrValue(['space-x-2 h-4', classNames])} ">
	{#if prev}
		<ButtonCarouselPrev {rounded} {white} />
	{/if}
	{#if next}
		<ButtonCarouselNext {rounded} {white} />
	{/if}
</div>
